import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import AnalyticsListener from "@/components/AnalyticsListener";
import CookieConsent from "@/components/CookieConsent";
import Home from "@/pages/Home";
import AIAssistant from "@/pages/AIAssistant";
import ScamDetection from "@/pages/ScamDetection";
import Dashboard from "@/pages/Dashboard";
import Education from "@/pages/Education";
import VictimSupport from "@/pages/VictimSupport";
import Research from "@/pages/Research";
import ResearchDetail from "@/pages/ResearchDetail";
import EducationDetail from "@/pages/EducationDetail";
import AuthorProfile from "@/pages/AuthorProfile";
import SocialMedia from "@/pages/SocialMedia";
import Awareness from "@/pages/Awareness";
import Volunteer from "@/pages/Volunteer";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App grain">
      <HelmetProvider>
        <BrowserRouter>
        <AnalyticsListener />
        <Toaster position="top-right" theme="dark" toastOptions={{ style: { background: "#101317", border: "1px solid #00D4FF33", color: "#F4F7F8" } }} />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/ai-assistant" element={<AIAssistant />} />
            <Route path="/scam-detection" element={<ScamDetection />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/education" element={<Education />} />
            <Route path="/education/:slug" element={<EducationDetail />} />
            <Route path="/victim-support" element={<VictimSupport />} />
            <Route path="/research" element={<Research />} />
            <Route path="/research/:id" element={<ResearchDetail />} />
            <Route path="/authors/:slug" element={<AuthorProfile />} />
            <Route path="/social-media" element={<SocialMedia />} />
            <Route path="/awareness" element={<Awareness />} />
            <Route path="/volunteer" element={<Volunteer />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
